// Mirrors the server's SalesAdminUserIds.Normalize (Trim() + ToLowerInvariant()).
// SalesAdminMapping rows always store ids lowercased, but GetPrismInternalUsers
// returns PrismUserDetail.UserId raw-cased. Any UI comparison, Map/Set key, or
// diff between a stored id and a raw-cased id MUST go through this helper on
// both sides, or a case mismatch (e.g. real PrismHR ids not already lowercase)
// silently fails to match - which, for the Sales Admin mapping preload/diff,
// means every previously mapped BDM looks "removed" and gets soft-deleted.
export const normalizeUserId = (raw) => {
  if (raw === undefined || raw === null) return "";
  return String(raw).trim().toLowerCase();
};

export default normalizeUserId;
